import React from 'react';
import { Link } from 'react-router-dom';
import { lifeTaggerApi } from '../api/lifetaggerApi';
import { StudioIcon } from './StudioShell';

export default function StudioOverview() {
  const [result, setResult] = React.useState(null);
  const [error, setError] = React.useState(false);
  const [retry, setRetry] = React.useState(0);
  React.useEffect(() => {
    let active = true;
    setError(false);
    lifeTaggerApi
      .listLifeObjectsPage({ page: 1, limit: 6 })
      .then((data) => active && setResult(data))
      .catch(() => active && setError(true));
    return () => {
      active = false;
    };
  }, [retry]);
  return (
    <div className="lt-overview">
      <div className="lt-section-eyebrow">A WORLD OF POSSIBILITY</div>
      <h1 className="lt-page-title">
        Small moments.
        <br />
        <em>Extraordinary connections.</em>
      </h1>
      <p className="lt-page-description">
        Your home for everything you leave in the world.
      </p>
      <section className="lt-overview-hero">
        <div>
          <span className="lt-section-eyebrow">MAKE IT MEANINGFUL</span>
          <h2>
            Every place
            <br />
            has a story.
            <br />
            <em>Leave yours.</em>
          </h2>
          <p>
            A voice, a memory, an invitation. Connect your content to the people
            and places that make it matter.
          </p>
          <Link className="lt-button lt-button-light" to="/objects?create=1">
            <StudioIcon name="plus" size={17} /> Create a LifeObject
          </Link>
        </div>
        <span className="lt-image-caption">
          A moment waiting to be discovered.
        </span>
      </section>
      <div className="lt-overview-links">
        {[
          [
            'collection',
            'Your collection',
            result?.total != null
              ? `${result.total} LifeObjects`
              : 'Your content, connected',
            '/objects',
          ],
          ['signals', 'LifeCodes', 'Choose where discovery begins', '/qrcode'],
          [
            'media',
            'Your media library',
            'Images, voices, stories and more',
            '/media',
          ],
        ].map(([icon, title, copy, to]) => (
          <Link to={to} key={to}>
            <span className="lt-feature-icon">
              <StudioIcon name={icon} />
            </span>
            <div>
              <h3>{title}</h3>
              <p>{copy}</p>
            </div>
            <StudioIcon name="arrow" />
          </Link>
        ))}
      </div>
      <div className="lt-section-heading">
        <div>
          <span className="lt-section-eyebrow">PICK UP WHERE YOU LEFT OFF</span>
          <h2>From your collection</h2>
        </div>
        <Link to="/objects">
          View collection <StudioIcon name="arrow" size={16} />
        </Link>
      </div>
      {error ? (
        <div className="lt-empty">
          Your collection couldn’t load.{' '}
          <button onClick={() => setRetry(retry + 1)}>Try again</button>
        </div>
      ) : !result ? (
        <div className="lt-empty">Loading your collection…</div>
      ) : (
        <div className="lt-recent-list">
          {result.items.map((item) => (
            <Link
              to={`/objects?preview=${encodeURIComponent(item.id)}`}
              key={item.id}
            >
              <span className="lt-feature-icon">
                <StudioIcon
                  name={
                    item.anchors?.some((a) => a.type === 'spatial')
                      ? 'spatial'
                      : 'collection'
                  }
                />
              </span>
              <div>
                <strong>{item.name}</strong>
                <small>
                  {item.audience?.visibility === 'public'
                    ? 'Public experience'
                    : 'Private audience'}{' '}
                  · {item.content?.length || 0} content items
                </small>
              </div>
              <span className={`lt-status ${item.lifecycle?.status}`}>
                {item.lifecycle?.status === 'active'
                  ? 'Published'
                  : item.lifecycle?.status}
              </span>
              <StudioIcon name="arrow" size={18} />
            </Link>
          ))}
          {!result.items.length && (
            <p>Your first LifeObject starts a new connection.</p>
          )}
        </div>
      )}
    </div>
  );
}
